import { SplatViewer } from '@/components/SplatViewer/SplatViewer'

export function ARTest() {
  return (
    <div className="min-h-screen bg-gray-900">
      <div className="container mx-auto py-8">
        <h1 className="text-3xl text-white font-bold mb-8">AR Test Page</h1>
        
        <div className="bg-gray-800 rounded-lg p-4 mb-8">
          <h2 className="text-xl text-white mb-4">Test Model with AR Support</h2>
          <p className="text-gray-400 mb-4">
            This page demonstrates the AR functionality. On supported devices:
          </p>
          <ul className="list-disc list-inside text-gray-400 mb-4">
            <li>WebXR AR: Available on Android Chrome with AR support</li>
            <li>Device Orientation AR: Fallback for iOS Safari and other mobile browsers</li>
            <li>Touch controls: Single finger drag to rotate, two fingers to zoom/pan</li>
          </ul>
        </div>
        
        <div className="h-[600px] rounded-lg overflow-hidden">
          <SplatViewer
            modelUrl="/api/v2/models/f47ac10b-58cc-4372-a567-0e02b2c3d479/download"
            className="w-full h-full"
            controls={true}
            showUI={true}
            showAxes={true}
            xrEnabled={true}
            xrSessionType="ar"
          />
        </div>
      </div>
    </div>
  )
}